import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AgentAssistant from '../components/AgentAssistant';
import ShuTongCharacter from '../components/ShuTongCharacter';
import { studyAPI } from '../api/study';
import './AgentChat.css';

function AgentChat() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedPoem, setSelectedPoem] = useState(location.state?.selectedPoem || null);
  const addedPoemIdRef = useRef(null);

  useEffect(() => {
    const poemId = new URLSearchParams(location.search).get('poemId');
    if (!selectedPoem && poemId) {
      studyAPI.getPoemDetail(parseInt(poemId, 10))
        .then(poem => {
          if (poem) setSelectedPoem(poem);
        })
        .catch(() => {});
    }
  }, [location.search, selectedPoem]);

  const handlePoemAdded = (poemId) => {
    addedPoemIdRef.current = poemId;
    studyAPI.getPoemDetail(poemId)
      .then(poem => {
        if (poem) setSelectedPoem(poem);
      })
      .catch(() => {});
  };

  const handleBack = () => {
    const from = location.state?.from || '/study';
    const fromState = location.state?.fromState || {};

    if (addedPoemIdRef.current) {
      navigate(from, {
        state: { ...fromState, addedPoemId: addedPoemIdRef.current }
      });
      return;
    }

    if (location.state?.from) {
      navigate(from, { state: fromState });
      return;
    }

    navigate(-1);
  };

  const backLabel = location.state?.from === '/game'
    ? '返回挑战'
    : location.state?.from === '/exchange'
      ? '返回换礼物'
      : location.state?.from === '/personal'
        ? '返回我的'
        : '返回';

  return (
    <div className="agent-chat-page">
      <header className="agent-chat-header">
        <button type="button" className="agent-chat-back" onClick={handleBack}>
          ← {backLabel}
        </button>
        <div className="agent-chat-title">
          <ShuTongCharacter className="agent-chat-mascot" />
          <div>
            <h1>小书童</h1>
            <p>{selectedPoem ? `正在学习《${selectedPoem.title}》` : '你的古诗学习伙伴'}</p>
          </div>
        </div>
      </header>

      <main className="agent-chat-main">
        <AgentAssistant
          selectedPoem={selectedPoem}
          onPoemAdded={handlePoemAdded}
          fullPage
        />
      </main>
    </div>
  );
}

export default AgentChat;
